import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ButtonsAngularModule } from 'rev-shared/ui/buttons/ButtonsAngular.Module';
import { CheckboxAngularModule } from 'rev-shared/ui/checkbox/CheckboxAngular.Module';
import { DirectivesAngularModule } from 'rev-shared/util/directives/DirectivesAngular.Module';
import { FormGroupAngularModule } from 'rev-shared/ui/formGroup/FormGroupAngular.Module';
import { PieChartModule } from 'rev-shared/ui/dataVisualization/pieChart/PieChart.Module';
import { PipesAngularModule } from 'rev-shared/pipes/Pipes.AngularModule';
import { SpinnerAngularModule } from 'rev-shared/ui/spinner/SpinnerAngular.Module';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TextInputAngularModule } from 'rev-shared/ui/text-input/TextInputAngular.Module';
import { TranslateModule } from '@ngx-translate/core';
import { ValidationAngularModule } from 'rev-shared/ui/validation/ValidationAngular.Module';
import { VbFlickityCarouselComponent } from 'rev-shared/ui/flickityCarousel/VbFlickityCarousel.Component';
import { VbUiTooltipComponent } from 'rev-shared/ui/tooltip/VbUiTooltip.Component';
import { VbRadioBtnModule } from 'rev-shared/ui/radio/VbRadioBtn.Module';

import { VbWebcastEditPollViewComponent } from './VbWebcastEditPollView.Component';
import { VbWebcastPollsViewCompoment } from './VbWebcastPollsView.Component';
import { VbManagePollCardComponent } from './VbManagePollCard.Component';
import { VbAttendeePollCardComponent } from './VbAttendeePollCard.Component';
import { VbPollCardComponent } from './VbPollCard.Component';
const components = [
	VbWebcastEditPollViewComponent,
	VbWebcastPollsViewCompoment
];

@NgModule({
	declarations: components,
	exports: components,
	imports: [
		ButtonsAngularModule,
		CheckboxAngularModule,
		CommonModule,
		DirectivesAngularModule,
		FormGroupAngularModule,
		FormsModule,
		PieChartModule,
		PipesAngularModule,
		SpinnerAngularModule,
		TabsModule,
		TextInputAngularModule,
		TranslateModule,
		ValidationAngularModule,
		VbAttendeePollCardComponent,
		VbFlickityCarouselComponent,
		VbManagePollCardComponent,
		VbPollCardComponent,
		VbUiTooltipComponent,
		VbRadioBtnModule
	]
})
export class VbWebcastPollsModule {}
